// extracted by mini-css-extract-plugin
export default {"button":"UploadAction_button__sjl63"};